import axios from 'axios';
import development from '../environments/development';
import production from '../environments/production';

const API_URL = process.env.NODE_ENV === 'development' ? development.apiUrl : production.apiUrl;

axios.defaults.baseURL = API_URL;

export default axios;